module.exports = __webpack_public_path__ + "img/pIndex-ins-h.e93115c9.png";